import { render, staticRenderFns } from "./FreeTextBlock.vue?vue&type=template&id=401dee80&"
import script from "./FreeTextBlock.vue?vue&type=script&lang=js&"
export * from "./FreeTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports